import styled, { css } from "styled-components";
import { Link as ScrollLink } from "react-scroll";

export const Root = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1280px;

  @media (max-width: 1023px) {
    align-items: center;
    padding: 12px 24px;
  }

  @media (min-width: 1024px) {
    align-items: flex-start;
    padding: 24px 80px;
  }
`;

export const Logo = styled.img`
  flex-shrink: 0;

  @media (max-width: 1023px) {
    width: 80px;
  }

  @media (min-width: 1024px) {
    width: 96px;
  }
`;

export const MenuButton = styled.button`
  width: 48px;
  height: 48px;
  padding: 0;
  color: #fff;

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const MenuContainer = styled.nav`
  display: flex;
  align-items: center;
  column-gap: 40px;

  @media (max-width: 1023px) {
    display: none;
  }
`;

const styledLink = css`
  color: #c3c3c3;
  font-family: "YWFT Ultramagnetic";
  text-transform: uppercase;
  cursor: pointer;

  &:hover,
  &.--active {
    color: #fff;
  }

  @media (max-width: 1023px) {
    font-size: 56px;
    line-height: 56px;
    text-align: right;
  }

  @media (min-width: 1024px) {
    padding-bottom: 4px;
    font-size: 18px;
  }
`;

export const Link = styled(ScrollLink)`
  ${styledLink}

  @media (min-width: 1024px) {
    &.--active {
      box-shadow: 0 4px 0 0 #dc9b00;
    }
  }
`;

export const ButtonLink = styled.button`
  ${styledLink}

  @media (max-width: 1023px) {
    display: none;
  }
`;
